<div class="cart-section">
  <div class="flex justify-end" style="margin-bottom: 20px">
    <div
      class="flex column justify-end gap-4px total-container"
      style="margin-bottom: 12px">
      <span>In der Tüte</span>
      <span class="total">
        € {{ residentCart?.total || 0 | number: '1.2-2' }}
      </span>
    </div>
    <div class="bag" style="cursor: pointer">
      <mat-icon svgIcon="bag-icon" class="bag-icon"></mat-icon>
      <div class="items-count-container">
        <p
          class="items-count"
          [ngStyle]="{
            '--digitCount': (residentCart?.getTotalItemsCount || 0).toString()
              .length
          }">
          {{ residentCart?.getTotalItemsCount || 0 }}
        </p>
      </div>
    </div>
  </div>
  <app-empty-list-info
    *ngIf="!residentCart || residentCart.getTotalItemsCount === 0"
    [text]="noProductsText"></app-empty-list-info>
  <app-cart-products-table
    [hideHeaders]="true"
    *ngIf="residentCart && residentCart.getTotalItemsCount > 0"
    [dataSource]="residentCart?.products"
    [residentId]="residentControl?.value?.id"></app-cart-products-table>
  <div class="flex justify-end" style="margin-top: 30px">
    <app-button
      type="CANCEL"
      text="Zur Shop Ansicht"
      class="back-to-shop-button"
      [action]="closeDialog.bind(this)"></app-button>
  </div>
</div>
